<template>
  <div class="IncreaseWeightRange">
    <el-dialog
      title="添加重量范围"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="beforeCloseComponents"
    >
      <el-form
        class="custom-formItem"
        inline
        ref="formData"
        :model="formData"
        :rules="rulesFormData"
        label-width="110px"
      >
        <el-form-item label="重量范围名称" prop="weightName">
          <el-input v-model="formData.weightName"></el-input>
        </el-form-item>
        <el-form-item label="重量范围" required style="width: 50%;">
          <el-row type="flex" justify="space-between" align="middle">
            <el-form-item prop="smallValue" class="w100">
              <el-input v-model="formData.smallValue"></el-input>
            </el-form-item>
            <div style="padding:0 10px;">~</div>
            <el-form-item prop="bigValue" class="w100">
              <el-input v-model="formData.bigValue"></el-input>
            </el-form-item>
            <div style="padding:0 20px;white-space: nowrap;">单位：kg</div>
          </el-row>
        </el-form-item>
        <el-button
          type="primary"
          @click="handleIncrease"
          :loading="loadingIncrease"
          style="margin-top: 5px;"
        >添加</el-button>
      </el-form>

      <el-table :data="listTable" border size="small">
        <el-table-column prop="weightName" align="center" label="尺寸范围名称"></el-table-column>
        <el-table-column align="center" label="尺寸范围">
          <template slot-scope="scope">
            <span>{{ scope.row.smallValue }}</span>
            <span>~</span>
            <span>{{ scope.row.bigValue }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseWeightRange',
  data() {
    return {
      dialogVisible: false,
      formData: {
        weightName: '',
        smallValue: '',
        bigValue: ''
      },
      rulesFormData: {
        weightName: [
          { required: true, max: 10, message: '此项为必填项且长度不能超过10', trigger: 'blur' }
        ],
        smallValue: [
          { required: true, message: '此项为必填项', trigger: 'blur' }
        ],
        bigValue: [
          { required: true, message: '此项为必填项', trigger: 'blur' }
        ]
      },
      listTable: [],
      loadingIncrease: false
    }
  },
  methods: {
    initComponents() {
      this.dialogVisible = true

      this.getListTable()
    },
    beforeCloseComponents(done) {
      this.loadingIncrease = false
      this.$refs.formData.resetFields()
      this.$refs.formData.clearValidate()
      done()
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'logisticsConfigurationController/insertLogisticsWeight'
        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.$message.success('操作成功！')
            this.getListTable()
          }
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该重量范围数据吗？', '提示')
        .then(() => {
          const API = Baseurl + 'logisticsConfigurationController/deleteLogisticsWeight'
          const paramsData = {
            id: row.id
          }

          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功！')
              this.getListTable()
            } else if (code === 500) {
              this.$message.error(data)
            } else {
              this.$message.error('操作失败！')
            }
          })
        })
    },
    getListTable() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsWeightList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.IncreaseWeightRange {
  .custom-formItem {
    ::v-deep {
      .el-form-item__content {
        width: calc(100% - 110px);
      }
    }
  }
}
</style>
